import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=3961deea&"
import script from "./SaleInfo.vue?vue&type=script&lang=js&"
export * from "./SaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SaleInfo.vue?vue&type=style&index=0&id=3961deea&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports